import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecuperarContrasenaService {
  baseUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) {}

  postRecuperarContrasena(username) {
    return this.httpClient.post(this.baseUrl + '/recuperar-contrasena', {
      usuario: username
    });
  }

  postVerificarRecuperacionContrasena(token) {
    return this.httpClient.post(this.baseUrl + '/verficar-recuperacion', {
      token: token
    });
  }

  postCambiarContrasena(password, confirmPassword, token) {
    return this.httpClient.post(this.baseUrl + '/cambiar-contrasena', {
      nuevaContrasena: password,
      confirmarContrasena: confirmPassword,
      token: token
    });
  }
}
